module.exports = __webpack_public_path__ + "img/709.8667d10b.jpg";